import './section-image.css'
